import * as ActionGenerics from "../../Common/actionGenerics";
import * as ActionTypes from "./actionTypes";
import * as StoreTypes from "../DataTypes/storeTypes";
import * as RequestTypes from "../DataTypes/requestTypes";
import * as Fetch from "../../Common/fetch";
import * as Actions from "./actions";
import * as ProviderActions from "./providerActions";
import * as DateTypes from "../DataTypes/dateTypes";
import * as DateHelper from "../Helpers/dateFormatHelper";
import * as moment from "moment";
import * as CalendarHelper from "../Helpers/calendarHelper";
import * as Notifications from "../../Common/Notifications/helper";
import * as timeZoneUtils from "../../Common/timeZoneUtils";
import * as ServiceTypes from "../DataTypes/serviceTypes";

export function getAvailability(dispatch, state: StoreTypes.IStore) {
    const dateStep = state.stepsInfo[StoreTypes.Step.When] as StoreTypes.IAvailabilityStepInfo;

    const date = CalendarHelper.getShowingDateByInfo(dateStep);

    const year = date.year();
    const month = date.month() + 1;

    const request: RequestTypes.IDateRequest = {
        locationId: state.stepsInfo[StoreTypes.Step.Location].id,
        serviceId: state.stepsInfo[StoreTypes.Step.Service].id,
        providerId: state.stepsInfo[StoreTypes.Step.Provider].id,
        year: year,
        month: month,
        availabilityType:
            state.initialSettings.type === StoreTypes.BookingType.Class
                ? RequestTypes.AvailabilityType.Class
                : RequestTypes.AvailabilityType.Available,
        enableTimezones: state.initialSettings.isTimezonesEnabled,
        clientUtcOffset: timeZoneUtils.getTimeZoneUtcOffset(),
    };

    return Fetch.post<DateTypes.IPowerTimeMonth>(state.initialSettings.getAvailabilityUrl, request)
        .then((data) =>
            state.initialSettings.isTimezonesEnabled
                ? DateHelper.reformatDateTimezone(data)
                : DateHelper.reformatDate(data)
        )
        .then((data) => dispatch(updateAvailability(data)))
        .catch((data) => Notifications.error(data.message));
}

function updateAvailability(
    availability: DateTypes.Availability
): ActionGenerics.IParamAction<ActionTypes.Actions, DateTypes.Availability> {
    return { type: ActionTypes.Actions.UpdateAvailability, parameter: availability };
}

export function selectDate(day: moment.Moment): ActionGenerics.IParamAction<ActionTypes.Actions, moment.Moment> {
    return { type: ActionTypes.Actions.SelectDate, parameter: day };
}

function selectSlotInternal(slot: DateTypes.ISlot): ActionGenerics.IParamAction<ActionTypes.Actions, DateTypes.ISlot> {
    return { type: ActionTypes.Actions.SelectSlot, parameter: slot };
}

export function selectSlot(slot: DateTypes.ISlot) {
    return async (dispatch, getState: () => StoreTypes.IStore) => {
        dispatch(selectSlotInternal(slot));
        dispatch(selectGroup(slot));

        let state = getState();

        //when it is class
        if (slot.providerId) {
            dispatch(ProviderActions.selectProviderInternal(slot.providerId));
            await fetchDefaultGroupService(dispatch, state, slot.appointmentId);
            state = getState();
        }

        const providerSelected = state.stepsInfo[StoreTypes.Step.Provider].id > 0;

        if (providerSelected) {
            dispatch(Actions.moveNext());
        }
    };
}

export function selectProvider(id: number) {
    return (dispatch, getState: () => StoreTypes.IStore) => {
        dispatch(ProviderActions.selectProvider(id));
    };
}

export function navigateBefore(): ActionGenerics.IAction<ActionTypes.Actions> {
    return { type: ActionTypes.Actions.NavigateMonthBefore };
}

function navigateNextInternal(): ActionGenerics.IAction<ActionTypes.Actions> {
    return { type: ActionTypes.Actions.NavigateMonthNext };
}

export function navigateNext() {
    return (dispatch, getState: () => StoreTypes.IStore) => {
        dispatch(navigateNextInternal());

        const state = getState();

        const currentStepInfo = state.stepsInfo[StoreTypes.Step.When] as StoreTypes.IAvailabilityStepInfo;

        const showingData = CalendarHelper.getShowingDateByInfo(currentStepInfo);

        const year = showingData.year();
        const month = showingData.format("MM");

        if (state.availability[year] && state.availability[year][month]) {
            return Promise.resolve();
        }

        return getAvailability(dispatch, state);
    };
}

export function flushAvailability(): ActionGenerics.IAction<ActionTypes.Actions> {
    return { type: ActionTypes.Actions.FlushAvailability };
}

export function selectGroup(slot: DateTypes.ISlot): ActionGenerics.IParamAction<ActionTypes.Actions, DateTypes.ISlot> {
    return { type: ActionTypes.Actions.SelectGroup, parameter: slot };
}

function fetchDefaultGroupService(dispatch, state: StoreTypes.IStore, appointmentId: number) {
    return Fetch.post<ServiceTypes.IService>(state.initialSettings.getDefaultGroupServiceUrl, { appointmentId })
        .then((data) => dispatch(updateService(data)))
        .catch((data) => Notifications.error(data.message));
}

function updateService(
    service: ServiceTypes.IService
): ActionGenerics.IParamAction<ActionTypes.Actions, ServiceTypes.IService> {
    return { type: ActionTypes.Actions.UpdateService, parameter: service };
}
